import { Box, Grid, Paper, useTheme } from "@mui/material";
import { Checkout } from "../../models/CheckoutLink";
import { connect } from "react-redux";
import { IAppState } from "../../redux/storeTypes";

export interface IFooterProps {
    checkout: Checkout;
}

const Footer = ({ checkout }: IFooterProps) => {
    const theme = useTheme();
    return (
        <Paper>
            <Grid container>
                <Grid item xs>
                    <Box component="div" textAlign={'center'} color={theme.palette.text.secondary} fontWeight={'fontWeightLight'} fontSize={'0.8em'}>Powered by MSB</Box>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Box component="div" textAlign={'center'} color={theme.palette.text.secondary} fontWeight={'fontWeightLight'} fontSize={'0.7em'}>
                        By using Checkout, you agree to accept our&nbsp;
                        <a href="https://payments.msbpay.com/Privacy_Policy.pdf" target={"_blank"} rel={"noreferrer"}>Privacy Policy</a>,&nbsp;
                        <a href="https://payments.msbpay.com/Terms_Of_Use.pdf" target={"_blank"} rel={"noreferrer"}>Terms of Use</a>&nbsp;and&nbsp;
                        <a href="https://payments.msbpay.com/Payment_Terms_and_Conditions.pdf" target={"_blank"} rel={"noreferrer"}>Terms & Conditions</a>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = (state: IAppState) => {
    return {
        checkout: state.checkout.checkout,
    };
};

export default connect(mapStateToProps)(Footer);